import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Footer from 'components/organisms/Footer';
import Header from 'components/organisms/Header';
import useWindowDimensions from 'hooks/useWindowDemensions';
import HelmetComponent from 'pages/HelmetComponent';

const MainLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { height } = useWindowDimensions();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);
  return (
    <main style={{ minHeight: `${height}px` }}>
      <HelmetComponent />
      <Header
        menu={[
          { label: 'Home Page', href: '/' },
          { label: 'About Us', href: '/about-us' },
          { label: 'Contact Us', href: '/contact-us' },
          { label: 'Products', href: '/products' },
        ]}
      />
      <Outlet />
      <Footer />
    </main>
  );
};

export default MainLayout;
